<template>
  <DialogTemplateToolkit
    :dialog="open"
    first_btn="Tenders.Continue"
    second_btn="Common.Cancel"
    :title="$t('Tenders.SureToGoAway')"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <slot name="activator-btn"/>
    </template>
    <template #card-text>
      {{ $t('Common.ChangesMayNotBeSaved') }}
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

export default {
  name: 'exitConfirmation',
  data() {
    return {
      open: false,
      options: {}
    }
  },
  mounted() {
    this.$root.$on('showExitConfirmation', this.onShowExitConfirmation)
    this.$root.$on('closeExitConfirmation', this.onCloseExitConfirmation)
  },
  beforeDestroy() {
    this.$root.$off('showExitConfirmation', this.onShowExitConfirmation)
    this.$root.$off('closeExitConfirmation', this.onCloseExitConfirmation)
  },
  methods: {
    onShowExitConfirmation(options) {
      this.options = options
      this.open = true
    },
    onCloseExitConfirmation() {
      this.open = false
    },
    apply() {
      this.$root.$emit('exitConfirmationApply', this.options)
      if (this.options?.submitExit ) {
        this.options?.submitExit(this.options?.submitExitProps ? this.options?.submitExitProps : null)
      }
      this.onCloseExitConfirmation()
    },
    close() {
      this.$root.$emit('exitConfirmationClose', this.options)
      if (this.options?.cancelExit ) {
        this.options?.cancelExit(this.options?.cancelExitProps ? this.options?.cancelExitProps : null)
      }
      this.onCloseExitConfirmation()
    }
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
